define.alias("shared/components/shared/ui/search-box/result-blank", "preview-grid/components/shared/ui/search-box/result-blank");